import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { getIndustry, getWithParentCategary } from "../../../../redux/categary/action";

export default function ProfileIndustryModal({
  edittype,
  formData,
  setFormData,
  setModalLanguage,
}) {
  const [selectedLanguage, setSelectedLanguage] = useState(formData.industries);

  const industrylist = useSelector(({ categary: { industrylist } }) => industrylist);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getIndustry());
  }, [])

  const handleLanguageChange = (selectedOption) => {
    setSelectedLanguage(selectedOption.id);
  };
  const handleSave = () => {
    setFormData((prevData) => ({
      ...prevData,
      industries: selectedLanguage,
      categories: [],
      skills: [],
    }));
    dispatch(getWithParentCategary(selectedLanguage))
    setModalLanguage(false);
  };


  return (
    <>
      <button
        onClick={() => setModalLanguage((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <div>
          <div>
            <div className="skill">
              <h6>Update your Industry</h6>
              <div className="skill-img">
                <button className="btn skill-img-btn">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/select-icon.svg`}
                    alt=""
                  />
                </button>
                <ReactSelect
                  getOptionLabel={(option) => option.title}
                  getOptionValue={(option) => option.id}
                  options={Array.isArray(industrylist) ? industrylist : []}
                  placeholder="Select Industry"
                  value={
                    Array.isArray(industrylist)
                      ? industrylist.find((option) => option.id == selectedLanguage) || null
                      : null
                  }
                  onChange={handleLanguageChange}
                />

              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
